module.exports = __webpack_public_path__ + "static/img/fireworks.ddd14645.png";